<template>
  <div class="sl-section">
    <div class="sl-section__header">
      {{ title }}
    </div>
    <div class="sl-section__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorConfigSection",
  props: {
    title: {
      type: [String, Object],
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-section {
  &__header {
    @include sectionTitle();
    padding-left: $spacing * 1.5;
    margin-bottom: $spacing * 1.5;
    height: 32px;
    line-height: 32px;
    user-select: none;
    font-weight: 500;

    &:before {
      left: 0;
    }
  }

  &__body {
    padding: $spacing * 1.5;
  }
}
</style>
